import { Guid } from "guid-typescript";
import { ProductSearchQuery } from "@/utils/ProductSearchQuery";

export class MortgageWatchGoals {
    bestMonthly: number = 50;
    bestLifetime: number = 50
    fixedTermDeal: number = 50;
    ethicalLender: number = 25;
    wellKnownLender: number = 50;
}

// export const enum EmploymentStatusEnum {
//     Employed = "Employed",
//     SelfEmployed = "Self Employed",
//     Contractor = "Contractor",
//     Retired = "Retired",
//     Unemployed = "Unemployed"
// }
//
// export const enum CreditScoreEnum {
//     VeryPoor = "Very Poor",
//     Poor = "Poor",
//     Average = "Average",
//     Good = "Good",
//     Excellent = "Excellent"
// }

export class PropertyDetails {
    urn: string | null = null;
    name: string | null = null;
    address: string | null = null;
    postcode: string | null = null;
    longitude: number | null = null;
    latitude: number | null = null;
    postcoder: any | null = null;
    
    getName() : string | null {
        if (this.postcoder == null) {
            return null;
        }
        else {
            return this.postcoder.organisation == null 
                ? this.postcoder.addressline1 + ", " + this.postcoder.addressline2 
                : this.postcoder.organisation + ", " + this.postcoder.addressline1;
        }
    }
    
    constructor(obj: object) {
        if (obj != null) {
            Object.assign(this, obj);
        }
    }
}

export class MortgageDetails extends ProductSearchQuery {
    endOfFixedTerm: Date | null = null;
    
    constructor(obj: any) {
        super(obj);
        if (obj != null) {
            Object.assign(this, obj);
            if (!(this.endOfFixedTerm instanceof Date))
                this.endOfFixedTerm = new Date(obj.endOfFixedTerm);
        }
    }
    
    get DaysRemaining() : number {
        if (this.endOfFixedTerm == null)
            return -1;

        const today = new Date();
        const diff = this.endOfFixedTerm.getTime() - today.getTime();
        
        return diff < 0 ? 0 : Math.ceil(diff / (1000 * 3600 * 24));
    }
}

// export class FinancialDetails {
//     creditScore: CreditScoreEnum | undefined;
//     employmentStatus: EmploymentStatusEnum | undefined;
// }

export class MortgageWatchQuery {
    get Description() : string | null {
        return this.name != null 
            ? this.name 
            : this.property != null ? this.property.name : "Default Property Name";
    }
    
    uid: string = Guid.create().toString();
    name: string | null = null;
    propertyType: string | null = null;
    property: PropertyDetails | null = null;
    mortgage: MortgageDetails | null = null;

    constructor(obj: any) {
        if (obj != null) {
            Object.assign(this, obj);
            this.mortgage = new MortgageDetails(obj.mortgage);
            this.property = new PropertyDetails(obj.property);
        }
    }
    
    get ProductSearchQuery() : ProductSearchQuery | null {
        const searchQuery = ProductSearchQuery.newRemortgage(
            this.mortgage?.propertyValue, 
            this.mortgage?.remainingBalance, 
            this.mortgage?.term);
        searchQuery.currentLender = this.mortgage?.currentLender;
        searchQuery.currentMonthly = this.mortgage?.currentMonthly;
        
        return searchQuery;
    }
}
